<button
  type="button"
  class="navigation-card"
  [disabled]="disabled()"
  (click)="onClick($event)"
>
  <span class="navigation-card__content">
    <ng-content></ng-content>
  </span>
  <span class="navigation-card__arrow" aria-hidden="true">›</span>
</button>
